export const menuData = [
    { title: "Home", link: "/"},
    { title: "Mobile", link: "/portfolio"},
    { title: "Website", link: "/"},
    { title: "UI Kit", link: "/dashboard"},
    { title: "Icons", link: "/admin"},
    { title: "Inspiration", link: "/inspiration"},
]